import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
          <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-6 text-center">
            <span
              aria-hidden
              className="mx-auto flex size-12 items-center justify-center rounded-full bg-negative-soft text-xl text-negative"
            >
              !
            </span>
            <h1 className="mt-3 text-lg font-semibold tracking-tight">Något gick fel</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Ett oväntat fel inträffade. Prova att ladda om sidan.
            </p>
            <Button type="button" onClick={() => window.location.reload()} className="mt-5 w-full">
              Ladda om
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
